/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EVoucherApprovalStatus } from '../models/EVoucherApprovalStatus';
import type { EVoucherAttachmentCreatedSchema } from '../models/EVoucherAttachmentCreatedSchema';
import type { EVoucherAttachmentReadSchema } from '../models/EVoucherAttachmentReadSchema';
import type { EVoucherCancelSchema } from '../models/EVoucherCancelSchema';
import type { EVoucherConfigCheckSchema } from '../models/EVoucherConfigCheckSchema';
import type { EVoucherConfigCheckSubmitSchema } from '../models/EVoucherConfigCheckSubmitSchema';
import type { EVoucherConfigSignRequestSchema } from '../models/EVoucherConfigSignRequestSchema';
import type { EVoucherCreateSchema } from '../models/EVoucherCreateSchema';
import type { EVoucherDetailSchema } from '../models/EVoucherDetailSchema';
import type { EVoucherDraftSchema } from '../models/EVoucherDraftSchema';
import type { EVoucherPingSchema } from '../models/EVoucherPingSchema';
import type { EVoucherSignalCodeListSchema } from '../models/EVoucherSignalCodeListSchema';
import type { EVoucherStatus } from '../models/EVoucherStatus';
import type { PagedEVoucherDetailSchema } from '../models/PagedEVoucherDetailSchema';
import type { SignSubmitSchema } from '../models/SignSubmitSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EvouchersApi {
    /**
     * Create Evoucher
     * Create an ePoukaz draft and return the signing material. Required Permission: create_evoucher
     * @returns EVoucherDraftSchema Created
     * @throws ApiError
     */
    public static evoucherCreateEvoucherPost({
        requestBody,
    }: {
        requestBody: EVoucherCreateSchema,
    }): CancelablePromise<EVoucherDraftSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/evouchers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Evoucher List
     * List ePoukazy. Required Permission: get_evoucher_list
     * @returns PagedEVoucherDetailSchema OK
     * @throws ApiError
     */
    public static evoucherGetEvoucherListGet({
        patientId,
        status,
        approvalStatus,
        limit = 100,
        offset,
    }: {
        patientId?: (string | null),
        status?: (EVoucherStatus | null),
        /**
         * Filter by one or more SÚKL StavSchvalovani values
         */
        approvalStatus?: (Array<EVoucherApprovalStatus> | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedEVoucherDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/evouchers/',
            query: {
                'patient_id': patientId,
                'status': status,
                'approval_status': approvalStatus,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Evoucher Configuration
     * Build the AppPingZEP sign-request to verify the doctor's certificate. Required Permission: verify_evoucher_config
     * @returns EVoucherConfigSignRequestSchema OK
     * @throws ApiError
     */
    public static evoucherGetEvoucherConfigurationGet(): CancelablePromise<EVoucherConfigSignRequestSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/evouchers/configuration/sign-request/',
        });
    }
    /**
     * Check Evoucher Configuration
     * Verify the ePoukaz configuration via a client-signed AppPingZEP. Required Permission: verify_evoucher_config
     * @returns EVoucherConfigCheckSchema OK
     * @throws ApiError
     */
    public static evoucherCheckEvoucherConfigurationPost({
        requestBody,
    }: {
        requestBody: EVoucherConfigCheckSubmitSchema,
    }): CancelablePromise<EVoucherConfigCheckSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/evouchers/configuration/checks/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Ping Evoucher
     * Verify connectivity to the SÚKL ePoukaz system via AppPing. Required Permission: verify_evoucher_config
     * @returns EVoucherPingSchema OK
     * @throws ApiError
     */
    public static evoucherPingEvoucherGet(): CancelablePromise<EVoucherPingSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/evouchers/ping/',
        });
    }
    /**
     * Get Evoucher Signal Codes
     * List the signal-code ePoukazy SÚKL holds for a patient, so the prescriber can fill the datum signálního kódu from the announcement instead of from memory. Required Permission: get_evoucher_signal_codes
     * @returns EVoucherSignalCodeListSchema OK
     * @throws ApiError
     */
    public static evoucherGetEvoucherSignalCodesGet({
        patientId,
        signalCode,
    }: {
        patientId: string,
        /**
         * SÚKL kód signálního kódu, např. 0082747 pro vlhké krytí
         */
        signalCode?: (string | null),
    }): CancelablePromise<EVoucherSignalCodeListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/evouchers/signal-codes/',
            query: {
                'patientId': patientId,
                'signalCode': signalCode,
            },
        });
    }
    /**
     * Set Evoucher Signature
     * Attach the client-produced signature to the ePoukaz and send it to SÚKL. Required Permission: sign_evoucher
     * @returns EVoucherDetailSchema OK
     * @throws ApiError
     */
    public static evoucherSetEvoucherSignaturePut({
        evoucherId,
        requestBody,
    }: {
        evoucherId: string,
        requestBody: SignSubmitSchema,
    }): CancelablePromise<EVoucherDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/evouchers/{evoucher_id}/signature/',
            path: {
                'evoucher_id': evoucherId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Sync Evoucher Approval
     * Refresh the ZP approval status of an ePoukaz from SÚKL. Required Permission: sync_evoucher_approval
     * @returns EVoucherDetailSchema OK
     * @throws ApiError
     */
    public static evoucherSyncEvoucherApprovalPost({
        evoucherId,
    }: {
        evoucherId: string,
    }): CancelablePromise<EVoucherDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/evouchers/{evoucher_id}/approval-syncs/',
            path: {
                'evoucher_id': evoucherId,
            },
        });
    }
    /**
     * Get Evoucher Attachment List
     * List the ePoukaz attachments held at SÚKL. Required Permission: get_evoucher_attachment_list
     * @returns EVoucherAttachmentReadSchema OK
     * @throws ApiError
     */
    public static evoucherGetEvoucherAttachmentListGet({
        evoucherId,
    }: {
        evoucherId: string,
    }): CancelablePromise<Array<EVoucherAttachmentReadSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/evouchers/{evoucher_id}/attachments/',
            path: {
                'evoucher_id': evoucherId,
            },
        });
    }
    /**
     * Create Evoucher Attachment
     * Attach a supporting document to an ePoukaz via SÚKL PripojitPrilohu. The name SÚKL stores comes from the uploaded file — SÚKL reads the file type off its extension. Required Permission: create_evoucher_attachment
     * @returns EVoucherAttachmentCreatedSchema Created
     * @throws ApiError
     */
    public static evoucherCreateEvoucherAttachmentPost({
        evoucherId,
        formData,
    }: {
        evoucherId: string,
        formData: {
            /**
             * SÚKL typ_prilohy (CommonSchema.xsd).
             */
            attachment_type: 'CENKAL' | 'TECHPOP' | 'ZDRDOK' | 'OST';
            file: Blob;
        },
    }): CancelablePromise<EVoucherAttachmentCreatedSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/evouchers/{evoucher_id}/attachments/',
            path: {
                'evoucher_id': evoucherId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get Evoucher Attachment
     * Download one ePoukaz attachment from SÚKL. Required Permission: get_evoucher_attachment
     * @returns any OK
     * @throws ApiError
     */
    public static evoucherGetEvoucherAttachmentGet({
        evoucherId,
        attachmentId,
    }: {
        evoucherId: string,
        attachmentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/evouchers/{evoucher_id}/attachments/{attachment_id}/',
            path: {
                'evoucher_id': evoucherId,
                'attachment_id': attachmentId,
            },
        });
    }
    /**
     * Delete Evoucher Attachment
     * Cancel one ePoukaz attachment at SÚKL. Required Permission: delete_evoucher_attachment
     * @returns void
     * @throws ApiError
     */
    public static evoucherDeleteEvoucherAttachmentDelete({
        evoucherId,
        attachmentId,
    }: {
        evoucherId: string,
        attachmentId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/evouchers/{evoucher_id}/attachments/{attachment_id}/',
            path: {
                'evoucher_id': evoucherId,
                'attachment_id': attachmentId,
            },
        });
    }
    /**
     * Get Evoucher
     * Get ePoukaz detail. Required Permission: get_evoucher_detail
     * @returns EVoucherDetailSchema OK
     * @throws ApiError
     */
    public static evoucherGetEvoucherGet({
        evoucherId,
    }: {
        evoucherId: string,
    }): CancelablePromise<EVoucherDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/evouchers/{evoucher_id}/',
            path: {
                'evoucher_id': evoucherId,
            },
        });
    }
    /**
     * Cancel Evoucher
     * Cancel an ePoukaz via SÚKL ZrusitPoukaz (soft cancel). Required Permission: cancel_evoucher
     * @returns EVoucherDetailSchema OK
     * @throws ApiError
     */
    public static evoucherCancelEvoucherDelete({
        evoucherId,
        requestBody,
    }: {
        evoucherId: string,
        requestBody: EVoucherCancelSchema,
    }): CancelablePromise<EVoucherDetailSchema> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/evouchers/{evoucher_id}/',
            path: {
                'evoucher_id': evoucherId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Change Evoucher
     * Change an existing ePoukaz (full update) and return the signing material. Required Permission: update_evoucher
     * @returns EVoucherDraftSchema OK
     * @throws ApiError
     */
    public static evoucherChangeEvoucherPut({
        evoucherId,
        requestBody,
    }: {
        evoucherId: string,
        requestBody: EVoucherCreateSchema,
    }): CancelablePromise<EVoucherDraftSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/evouchers/{evoucher_id}/',
            path: {
                'evoucher_id': evoucherId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Evoucher Slip
     * Download the ePoukaz slip PDF from SÚKL. Required Permission: get_evoucher_slip
     * @returns any OK
     * @throws ApiError
     */
    public static evoucherGetEvoucherSlipGet({
        evoucherId,
    }: {
        evoucherId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/evouchers/{evoucher_id}/slip/',
            path: {
                'evoucher_id': evoucherId,
            },
        });
    }
}
